class Transformer {
    async transform(data) {
    }
}

export {Transformer};
